import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    uid: ""
  },
  getters: {
    uid: state => {
      return state.uid
    }
  },
  mutations: {
    updateUid(state, data) {
      state.uid = data
    }
  },
  actions: {
    updateUid({
      commit
    }, data) {
      commit("updateUid", data)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js